import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { ToastProvider } from '@/components/ui';
import { installUnauthorizedHandler, queryClient } from '@/shared/queryClient';
import '@/i18n';
import '@/styles/index.css';

// Wire the ONE global 401 handler before any query can fire (see queryClient.ts).
installUnauthorizedHandler();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <App />
      </ToastProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
